module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/ultilities/workflow-alert/workflow-alert-grid/workflow-alert-grid.component.css
// module id = ./src/app/ultilities/workflow-alert/workflow-alert-grid/workflow-alert-grid.component.css
// module chunks = main